import { createContext, useContext } from "react";

import type { AccordionItemContextValue, AccordionRootContextValue } from "./types";

/**
 * Radix keeps its accordion state internal, so the web Root and Item mirror
 * it into these for the shared hooks. Both throw outside their provider, as
 * the native ones do.
 */
export const AccordionRootContext = createContext<AccordionRootContextValue | null>(null);
export const AccordionItemContext = createContext<AccordionItemContextValue | null>(null);

export const useRootContext = (): AccordionRootContextValue => {
  const context = useContext(AccordionRootContext);
  if (!context) {
    throw new Error(
      "Accordion compound components cannot be rendered outside the Accordion component",
    );
  }
  return context;
};

export const useItemContext = (): AccordionItemContextValue => {
  const context = useContext(AccordionItemContext);
  if (!context) {
    throw new Error(
      "AccordionItem compound components cannot be rendered outside the AccordionItem component",
    );
  }
  return context;
};
